import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { useDeviceType } from '@cian/ui-kit/responsive';
import { ValuationNotFound } from './components';
import * as styles from './styles.css';
import { mergeStyles } from '@cian/utils';

export interface IValuationSearchProps {
  isLoading: boolean;
  disabled: boolean;
  isNotFound: boolean;
  submitText: string;

  onClick(): void;
}

export const OpenDataPaymentForm: React.FC<IValuationSearchProps> = ({
  isLoading,
  disabled,
  onClick,
  isNotFound,
  submitText,
}) => {
  const isDesktop = useDeviceType() === 'desktop';

  return (
    <div {...mergeStyles(styles['container'], isDesktop ? styles['container_desktop'] : styles['container_mobile'])}>
      {isNotFound && (
        <div className={styles['message']}>
          <ValuationNotFound isDesktop={isDesktop} />
        </div>
      )}
      <div className={styles['action']}>
        <Button size="M" loading={isLoading} disabled={disabled} onClick={onClick} fullWidth>
          {submitText}
        </Button>
      </div>
    </div>
  );
};

OpenDataPaymentForm.displayName = 'OpenDataPaymentForm';
